import { Button, Loading } from '@tecsinapse/cortex-react'
import React from 'react'

interface ConfirmCancelProps {
  confirmLabel?: string
  cancelLabel?: string
  confirmDisabled?: boolean
  isSubmitting?: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmCancel = ({
  confirmLabel,
  cancelLabel,
  confirmDisabled = false,
  isSubmitting = false,
  onConfirm,
  onCancel
}: ConfirmCancelProps) => (
  <div className='flex flex-row space-x-mili'>
    <Button
      className='w-1/2'
      size='small'
      disabled={isSubmitting || confirmDisabled}
      onClick={onConfirm}
    >
      <div className='flex flex-row space-x-mili'>
        {isSubmitting && <Loading className='h-3 w-3' />}
        <p>{confirmLabel ?? 'Confirmar'}</p>
      </div>
    </Button>
    <Button
      className='w-1/2'
      intent='secondary'
      size='small'
      variant='text'
      disabled={isSubmitting}
      onClick={onCancel}
    >
      <p>{cancelLabel ?? 'Cancelar'}</p>
    </Button>
  </div>
)

export default ConfirmCancel
